import React, { useState } from 'react';
import { FiCalendar, FiClock, FiPlusCircle } from 'react-icons/fi';

const font = "'Outfit', sans-serif";
const BL = '#6366f1';
const C = { text: '#1e1b4b', sub: '#6b7280', border: '#e0e7ff', bg: '#eef2ff', white: '#fff' };

const ScheduleSupplyExams = () => {
    // 🚧 Needs OLD db svu_exam_schedule integration

    return (
        <div style={{ fontFamily: font }}>
            <h1 style={{ fontSize: 24, fontWeight: 900, color: C.text, margin: '0 0 8px', letterSpacing: -0.5 }}>Schedule Supply Exams</h1>
            <p style={{ color: C.sub, fontSize: 14, margin: '0 0 30px' }}>Organize supplementary examinations for students needing to clear backlog subjects.</p>

            <div style={{ background: C.white, borderRadius: 20, border: `1.5px solid ${C.border}`, padding: 40, textAlign: 'center', boxShadow: '0 4px 12px rgba(99,102,241,0.05)' }}>
                <FiCalendar size={48} color={BL} style={{ opacity: 0.2, marginBottom: 16 }} />
                <h3 style={{ fontSize: 18, fontWeight: 800, color: C.text, margin: '0 0 8px' }}>Supply Exam Scheduler</h3>
                <p style={{ color: C.sub, fontSize: 14, maxWidth: 500, margin: '0 auto' }}>
                    This module coordinates with the primary exam schedule database. It filters registered backlog students and generates new dedicated time slots and paper requests for teachers.
                    <br /><br />
                    <em>(UI coming soon)</em>
                </p>
            </div>
        </div>
    );
};

export default ScheduleSupplyExams;
